import isNil from 'lodash/fp/isNil';
import { store } from '../../../configuration/setup/store';
import { trace } from '../../../configuration/setup/trace';
import { facadeApiV3, PlugType } from '../../facade/facadeApiV3';
import { selectProfileType } from '../../vehicleProfile/vehicleProfileSelectors';
import {
    changeAssetLocked,
    changeAverageOutdoorTemperature,
    changeBatteryCapacity,
    changeBatteryPacksValue,
    changePlugType,
    lockVehicleType,
} from '../../vehicleProfile/vehicleProfileSlice';
import { updateAssetId } from '../widgetSlice';

export const SELECT_ASSET_EVENT = 'EVENT_SELECT_ASSET';

type SelectAssetType = {
    id: string;
};

export const selectAssetHandler = async (data: SelectAssetType) => {
    const assetId = data.id;
    store.dispatch(updateAssetId(assetId));
    if (!isNil(assetId)) {
        const request = store.dispatch(
            facadeApiV3.endpoints.getAssetData.initiate({ id: assetId }, { forceRefetch: true })
        );
        const { data: vehicle, isError } = await request;
        if (isError) {
            trace.error('Failed to fetch vehicle data for asset:', assetId);
        } else if (!isNil(vehicle)) {
            store.dispatch(changeAssetLocked(vehicle));

            if (!isNil(vehicle.temperature)) {
                store.dispatch(changeAverageOutdoorTemperature(vehicle.temperature));
            }

            const chargePortType = vehicle.batteryConfiguration?.chargePortType;
            if (chargePortType && chargePortType.length > 0) {
                const port = chargePortType[0].toUpperCase();
                if (port === 'MCS') {
                    store.dispatch(changePlugType({ value: PlugType.Mcs, isEditable: false }));
                } else {
                    store.dispatch(changePlugType({ value: PlugType.CcsCombo2, isEditable: false }));
                }
            }

            const batteryPacksNumber = vehicle.batteryConfiguration?.batteryPacksNumber;
            if (batteryPacksNumber && batteryPacksNumber !== 0) {
                const selectedProfile = selectProfileType(store.getState());
                if (!isNil(selectedProfile)) {
                    const { data: profileDetails } = await store.dispatch(
                        facadeApiV3.endpoints.getVehicleProfileDetails.initiate({ id: selectedProfile })
                    );
                    store.dispatch(
                        changeBatteryCapacity({
                            value: batteryPacksNumber * (profileDetails?.batteryCapacityPerPack ?? 0),
                            isEditable: false,
                        })
                    );
                }
                store.dispatch(changeBatteryPacksValue(batteryPacksNumber));
            }

            const { vehicleProfileId } = vehicle;
            if (!isNil(vehicleProfileId)) {
                const { data: profilesList } = await store.dispatch(
                    facadeApiV3.endpoints.getVehicleProfileList.initiate()
                );
                if (profilesList?.some(profile => profile.id === vehicleProfileId)) {
                    store.dispatch(lockVehicleType(vehicleProfileId));
                }
            } else {
                store.dispatch({ type: 'routeWidget/vehicleProfile/unlockVehicleType' });
            }
        }
        request.unsubscribe();
    }
};
